export default "__VITE_ASSET__Dq2lWbNH__"